<template>
  <div class="home">
    <StockTable />
  </div>
</template>

<script>
import StockTable from '@/components/StockTable.vue'

export default {
  name: 'HomeView',
  components: {
    StockTable
  }
}
</script>
